export enum EAnimalUrl {
  ANIMAL = 'animal',
  ANIMALS = 'animals',
  VISITATION = 'visitation',
  SEARCH = 'search',
  KEY = 'key',
}
